import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { ClientService } from '../services/client/client.service';
import { TranslateService } from '../services/translation/translate.service';

@Injectable({
  providedIn: 'root',
})
export class PathAccessibleGuard {
  constructor(
    private ClientService: ClientService,
    private Router: Router,
    private Translate: TranslateService,
  ) {}

  check(state: RouterStateSnapshot) {
    const lang = this.Translate.language;
    const currentPath = state?.url?.slice(1, 9999)?.replace(/^\w{2,3}\//, '').split('?')[0];
    const menuItems = [...(this.ClientService.client?.listOfNavbarItems || []), ...(this.ClientService.client?.listOfFooterNavbarItems || [])];
    const landingItem = menuItems.find(i => i.isLanding) || menuItems[0];

    let matchedMenuItem = menuItems.find((i) => {
      const itemPath = i.link?.replace(/^\//, '');
      return currentPath.match(itemPath);
    });

    return {matchedMenuItem, lang, landingItem};
  }

  public async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree
  > {

    await firstValueFrom(this.ClientService.clientLoaded$);
    const {matchedMenuItem, lang, landingItem} = this.check(state);
    const homeIsLanding = landingItem?.link === '/home';
    const currentPath = state?.url?.slice(1, 9999)?.replace(/^\w{2,3}\//, '').split('?')[0];

    if (!matchedMenuItem) {
      if (currentPath === '' && homeIsLanding) {
        return true;
      } else {
        const path = `${lang}${landingItem?.link || '/not-found'}`;
        this.Router.navigate([path], {replaceUrl: true});
        return false;
      }
    } else {
      return true;
    }
  } 
}
